/**
 * TanStack Query key factory (ADR-0002). One documented place for keys keeps
 * cache reads/writes and invalidations consistent across features.
 */
export const keys = {
  myBusinesses: (uid: string) => ['businesses', 'byOwner', uid] as const,
  business: (businessId: string) => ['business', businessId] as const,
  services: (businessId: string) => ['services', businessId] as const,
  staff: (businessId: string) => ['staff', businessId] as const,
  availability: (businessId: string) => ['availability', businessId] as const,
  readiness: (businessId: string) => ['readiness', businessId] as const,
  upcomingAppointments: (businessId: string) => ['appointments', businessId, 'upcoming'] as const,
  weekAppointments: (businessId: string, weekStartIso: string) =>
    ['appointments', businessId, 'week', weekStartIso] as const,
  calls: (businessId: string, range?: { from?: Date; to?: Date }) =>
    ['calls', businessId, range?.from?.getTime() ?? null, range?.to?.getTime() ?? null] as const,
  clients: (businessId: string) => ['clients', businessId] as const,
  client: (businessId: string, e164: string) => ['clients', businessId, e164] as const,
  clientAppointments: (businessId: string, e164: string) =>
    ['clients', businessId, e164, 'appointments'] as const,
  /** Prepaid billing (doc 42) — callable-backed, refreshed when the live
   * `billingSummary` on the business document changes. */
  billingOverview: (businessId: string) => ['billing', businessId, 'overview'] as const,
  billingHistory: (businessId: string) => ['billing', businessId, 'history'] as const,
  billingQuote: (businessId: string, packageId: string | null) => ['billing', businessId, 'quote', packageId] as const,
} as const;
